var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];

var adscript = function() {
  try {
    (function() {
      var gads = document.createElement('script');
      gads.async = true;
      gads.type = 'text/javascript';
      var useSSL = 'https:' == document.location.protocol;
      gads.src = (useSSL ? 'https:' : 'http:') + 
      '//www.googletagservices.com/tag/js/gpt.js';
      var node = document.getElementsByTagName('script')[0];
      node.parentNode.insertBefore(gads, node);
    })();

    googletag.cmd.push(function() {
    // googletag.defineSlot('/99819337/production/groupon.com/seo/seo_local', [[160, 600]], 'div-gpt-ad-1425070317256-0').addService(googletag.pubads());
    googletag.defineSlot('/99819337/production/groupon.com/seo/seo_local/728x90BTF', [728, 90], 'div-gpt-ad-1439925085884-0').addService(googletag.pubads());
    googletag.defineSlot('/99819337/production/groupon.com/seo/seo_local/728x90Carousel1', [728, 90], 'div-gpt-ad-1439924840199-0').addService(googletag.pubads());
    googletag.defineSlot('/99819337/production/groupon.com/seo/seo_local/728x90Carousel2', [728, 90], 'div-gpt-ad-1439924932272-0').addService(googletag.pubads());
    googletag.defineSlot('/99819337/production/groupon.com/seo/seo_local/728x90Carousel3', [728, 90], 'div-gpt-ad-1439925004801-0').addService(googletag.pubads());

    googletag.defineSlot('/99819337/production/Touch/SEO', [[300, 50]], 'div-gpt-ad-1437413051854-0').addService(googletag.pubads());
    googletag.defineSlot('/99819337/production/Touch/SEO', [[300, 250]], 'div-gpt-ad-1437413051854-1').addService(googletag.pubads());
    
    googletag.pubads().enableSingleRequest();
    googletag.enableServices();
    });
  }
  catch(ex){
    // do nothing  
  }
};

Finch && Finch.experiment("GSMDesktopInFlowAdsExperiment", { show: adscript });
Finch && Finch.experiment("GSMTouchAdsExperiment", { show: adscript });
